import { authGet } from "@api";

import { CategorySummaryResponse } from "@pages/overview/types";

export const fetchDemoCategorySummaries = (
  deploymentId: string
): Promise<CategorySummaryResponse> => {
  return authGet<CategorySummaryResponse>(
    `/api/agent/deployments/${deploymentId}/analytics/categories/demo_project`
  );
};
